import React from "react";
import { toast } from "react-hot-toast";
import Plan from "./Plan";
// import useAuth from "../../hooks/useAuth";
import useCart from "../../hooks/useCart";
import { useNavigate } from "react-router-dom";
import { initialPlan } from "../../constants/plans"; 

const plan = initialPlan;

export default function Pricings() {
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const handleOnClick = async () => {
    toast.loading("Redirecting to payment...", { id: "payment" });

    try {
      addToCart(plan);

      toast.dismiss("payment");
      navigate("/checkout");
    } catch (error) {
      toast.dismiss("payment");
      toast.error(
        error.message || "Failed to initiate payment. Please try again."
      );
    }
  };

  return (
    <div className="p-8 font-sans">
      <h1 className="text-3xl text-[#281D1BB2] font-bold text-center mb-4 2xl:mb-6 3xl:mb-8">
        Our Plan
      </h1>

      <div className="px-4 sm:w-4/5 lg:w-3/5 mx-auto">
        <Plan plan={plan} variant="primary" onClick={handleOnClick} />
      </div>
    </div>
  );
}
